import React, { useState, useEffect } from 'react'

import { Link } from 'react-router-dom'
import { Get, Delete } from '../../web_api/api'
import 'react-photo-view/dist/react-photo-view.css';
import { FaEdit, FaTrash } from "react-icons/fa";
export default function PromoList() {
    const [bannerList, setBannerList] = useState([])

    // to delete list's item
    const handleDelete = async (event) => {
        await Delete('/banner-photo/', event)
        const result = bannerList.filter(item => item._id !== event)
        setBannerList(result)
    }

    useEffect(() => {
        const getBlogs = async () => {
            const res = await Get('banner-photos')
            setBannerList(res.data)

        }
        getBlogs()

    }, [])
    return (
        <div>
            <div className='row'>
                <div className='content-wrapper w-75'>
                    {/* <!-- Content Header (Page header) --> */}
                    <div className='content-header'>
                        <div className='container-fluid'>
                            <div className='row mb-2'>
                                <div className='col-sm-12'>
                                    <ol className='breadcrumb'>
                                        <li className='breadcrumb-item active'>Banner List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Main content --> */}
                    <section class='content'>
                        <div class='container-fluid'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='card'>
                                        <Link to='/banner-create' className='card-header'>
                                            {/* <h3 className="card-title">Currency List</h3> */}

                                            <button
                                                type='button'

                                                className='btn btn-sm btn-primary float-right'
                                            >
                                                <i className='fa fa-plus'></i> &nbsp;Add
                                            </button>
                                        </Link>
                                        <div className='card-body'>


                                            {bannerList.map((item, index) => (
                                                <div className='row mt-4'>
                                                    <div className='col-3'>
                                                        <img src={"http://192.168.1.5:9090/uploads" + item.imgUrl} width='250px' height='120px' />
                                                    </div>


                                                    <span className='offset-1 col-1'>
                                                        <Link to={'/banner-update/' + item._id} className=''>
                                                            <button
                                                                type='button'

                                                                className='btn btn-sm btn-warning  float-right mt-5'
                                                            >
                                                                <FaEdit /> &nbsp;Update
                                                            </button>
                                                        </Link>

                                                    </span>
                                                    <span className='col-1'>
                                                        <button

                                                            onClick={() => handleDelete(item._id)}
                                                            className='btn btn-sm btn-danger  float-right mt-5'
                                                        >
                                                            <FaTrash /> &nbsp;Delete
                                                        </button>

                                                    </span>
                                                </div>


                                            ))}




                                        </div>
                                        <h5 className='text-red py-5 text-center text-decoration-underline'><b>Note</b> : If you want to add new Banner List , you should delete all items before creating!</h5>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
            </div>

        </div>

    )
}





